import {Component, Inject, Prop, Vue} from "vue-property-decorator";
import {Modal} from "~/components/modal";
import {XInput} from "~/components/forms/x-input";
import {Label} from "~/components/forms/label";
import {Group} from "~/lib/models/group";
import {className} from "~/lib/helpers/string";
import {getUsersManagementStore} from "~/modules/users/store";
import {isDefined} from "~/lib/helpers/guards";
import {AppSettings} from "~/lib/app-settings";

const usersManagementStore = getUsersManagementStore();

@Component
export class ModalGroupEdit extends Vue {

  @Inject() appSettings: AppSettings;
  @Prop({type: Boolean, default: false}) isActive: boolean;
  @Prop({type: Object, required: true}) group: Group;

  @usersManagementStore.Action saveGroup;

  private editGroup: Group = null;
  private isSaving = false;

  get isCreatedMode(){
    return !isDefined(this.group.id);
  }

  get isValid(){
    return this.editGroup.label?.length > 0;
  }

  created(){
    this.editGroup = this.group.clone();
  }

  cancel() {
    this.$emit("cancel");
  }

  async save() {
    if( this.isValid ){
      try {
        this.isSaving = true;
        const group = await this.saveGroup({group: this.editGroup, clientUUID: this.appSettings.clientUUID});
        this.$notify.success(this.isCreatedMode ? "Le groupe a été créé" : "Le groupe a été mis à jour");
        this.isSaving = false;

        this.$nextTick(() => {
          this.editGroup = group.clone();
          this.$emit("groupSaved", {group});
        });

      } catch (err) {
        console.log(err);
        this.$notify.error("Une erreur est survenue lors de l'enregistrement");
        this.isSaving = false;
      }
    }
  }

  render() {
    return (

      <Modal isActive={this.isActive} class="group-edit" onClose={this.cancel}>

        <div class="box">
          <div>
            <Label text="Nom du groupe"/>
            <XInput type="text" v-model={this.editGroup.label} placeholder="Nom de groupe requis"/>
          </div>

          <div class="actions m-t-20">
            <button class="button is-small" onClick={this.cancel}>Annuler</button>
            <button class={className(`button is-small is-primary`, {isLoading: this.isSaving})}
                    disabled={!this.isValid}
                    onClick={this.save}>Enregistrer
            </button>
          </div>

        </div>
      </Modal>
    );
  }

}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-560046be/modal-group-edit.tsx" });